import script from "./ErrorSubmitDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./ErrorSubmitDialog.vue?vue&type=script&setup=true&lang=ts"

import "./ErrorSubmitDialog.vue?vue&type=style&index=0&id=2900da6c&scoped=true&lang=less"

import exportComponent from "../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2900da6c"]])

export default __exports__